import { colors } from "../constants/colors.js";
import { themeVariables } from "../constants/tokens.js";
const {
  color
} = themeVariables;
const white = colors.black.white;
const palette = {
  primary: {
    main: color.surface.primary,
    contrastText: color.text.primary
  },
  secondary: {
    main: color.surface.secondary
  },
  error: {
    main: color.surface["error-primary"],
    contrastText: white
  },
  warning: {
    main: color.surface["warning-primary"]
  },
  info: {
    main: color.surface["info-primary"]
  },
  success: {
    main: color.surface["success-primary"]
  },
  text: {
    primary: color.text.primary,
    secondary: color.text.secondary,
    disabled: color.text.disabled
  },
  background: {
    default: color.surface.secondary,
    paper: color.surface.primary
  },
  divider: color.border.secondary,
  grey: {
    50: colors.black[50],
    100: colors.black[100],
    200: colors.black[200],
    300: colors.black[300],
    400: colors.black[400],
    500: colors.black[500],
    600: colors.black[600],
    700: colors.black[700],
    800: colors.black[800],
    900: colors.black[900]
  },
  common: {
    black: colors.black[950],
    white: "#fff"
  },
  tonalOffset: 0.2,
  contrastThreshold: 3,
  mode: "light"
};
export {
  palette as default
};
